import React from 'react';
import styled from 'styled-components';

import ohioLogo from '../../assets/ohio.png';
import iowaLogo from '../../assets/iowa.png';
import appConfig from '../../appConfig';
import USstateConfig from '../../Account/constants/USstateConfig';

const ResponsibleGambling = () => {
	return (
		<GamblingMessage>
			{appConfig.regions.usState === 'OH' && (
				<>
					<img src={ohioLogo} alt="Ohio Casino Control Commission Logo" />
					<p>
						If you or someone you know has a gambling problem and wants help call{' '}
						<a href={`tel:${USstateConfig.gamblingPhone}`}>{USstateConfig.gamblingPhoneDisplay}</a>
					</p>
				</>
			)}
			{appConfig.regions.usState === 'IA' && (
				<>
					<a href="https://www.iowagaming.org/responsible-gaming/" target="_blank" rel="noreferrer">
						<img src={iowaLogo} alt="Iowa Responsible Gambling" />
					</a>
					<p>
						If you or someone you know has a gambling
						<br />
						problem and wants help call{' '}
						<a href={`tel:${USstateConfig.gamblingPhone}`}>{USstateConfig.gamblingPhoneDisplay}</a>
					</p>
				</>
			)}
		</GamblingMessage>
	);
};

export default ResponsibleGambling;

const GamblingMessage = styled.div`
	display: flex;
	align-items: center;
	max-width: 320px;
	color: black;
	margin: 1rem auto;

	img {
		width: 50px;
		height: 50px;
		margin-right: 1rem;
	}

	p {
		font-size: 0.8rem;
		line-height: 1.2;
	}
`;
